import React from 'react';
import { DisconnectBanner, SearchBox, SearchField } from './styled';
import { ReactComponent as SearchIcon } from '../../../../../../assets/icons/search.svg';

type Props = {
    searchTerm: string;
    onSearchChange: (value: string) => void;
    onSearchSubmit: (term: string) => void;
    wsConnected: boolean | null;
};

const HeaderControls: React.FC<Props> = ({
    searchTerm,
    onSearchChange,
    onSearchSubmit,
    wsConnected
}) => {
    return (
        <>
            <SearchBox>
                <SearchField
                    fullWidth
                    placeholder="Search messages"
                    size="small"
                    value={searchTerm}
                    onChange={(e) => {
                        const newValue = e.target.value;
                        onSearchChange(newValue);
                        if (!newValue || newValue.trim() === '') {
                            onSearchSubmit(newValue);
                        }
                    }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            onSearchSubmit(searchTerm);
                        }
                    }}
                    InputProps={{
                        endAdornment: <SearchIcon />
                    }}
                />
            </SearchBox>
            {wsConnected === false && (
                <DisconnectBanner>
                    <span className="ws-dot" />
                    Reconnecting…
                </DisconnectBanner>
            )}
        </>
    );
};

export default HeaderControls;
